import { MemoizedDecisionNode } from '../MemoizedNodes';
import sharedEditorCallbacks from '../utils/sharedEditorCallbacks';

export default function DecisionNodeItem({
  task,
  commonProps,
  handlers,
  props,
  connectingFrom,
  connectingBranch,
  lockStates,
  statuses,
  allCategories,
  allTags,
  allTasks,
  onDecisionAnswerChange,
  onDecisionOptionsChange,
}) {
  return (
    <MemoizedDecisionNode
      {...commonProps}
      {...sharedEditorCallbacks(props, handlers)}
      connectingBranch={connectingFrom === task.id ? connectingBranch : null}
      lockState={lockStates[task.id]}
      statuses={statuses}
      allCategories={allCategories}
      allTags={allTags}
      allTasks={allTasks}
      onAnswerChange={onDecisionAnswerChange}
      onOptionsChange={onDecisionOptionsChange}
    />
  );
}
